import { getDefaultUpperBookingChackinDates } from './helpers'

const parseUpperBookingScriptSrc = (lang = 'pl') =>
    `//open.upperbooking.com/js/Booking.min.js?locale=${lang}&site=hotelwillaportresort&v=98680707315e99ccd3908270e0f913d9`

const openUpperBookingModal = () => {
    const checkinDates = getDefaultUpperBookingChackinDates()
    window?.Booking?.Open(checkinDates)
    return false
}

const openExplicitUpperBookingOffer = (offerID, dataType) => (e) => {
    e.stopPropagation()
    e.preventDefault()
    if (dataType === 'room') {
        window?.Booking?.Open({ RoomID: offerID })
    } else {
        window?.Booking?.OpenSidebar({ OfferID: offerID })
    }
    return false
}

const initUpperBookingScript = () => {
    const previousScript = document.querySelector('#bookingButtonScript')
    const mainUpperBookingButton = document.querySelector('#ub-button-main')
    if (!mainUpperBookingButton) return
    if (previousScript) previousScript.remove()

    const lang = mainUpperBookingButton.getAttribute('data-lang') ?? 'pl'

    const upperBookingScript = document.createElement('script')
    upperBookingScript.type = 'text/javascript'
    upperBookingScript.defer = true
    upperBookingScript.async = true
    upperBookingScript.src = parseUpperBookingScriptSrc(lang)
    upperBookingScript.id = 'bookingButtonScript'

    document.body.appendChild(upperBookingScript)

    const remainingReservationButtons = Array.from(document.querySelectorAll('#ub-button'))
    const allReservationButtons = [...remainingReservationButtons, mainUpperBookingButton]
    allReservationButtons.map((button) => {
        button.addEventListener('click', openUpperBookingModal)
    })

    const bookRoomButton = Array.from(document.querySelectorAll('#book-room-button'))
    bookRoomButton.map((button) => {
        const dataId = button.getAttribute('data-id')
        const dataType = button.getAttribute('data-type')
        button.addEventListener('click', openExplicitUpperBookingOffer(dataId, dataType))
    })
}

initUpperBookingScript()
